/**
 * Mobile menu toggle for the header navigation.
 * Toggles visibility of the navigation block (top + main nav) on small viewports.
 */
export default class MobileMenu {
  constructor(header) {
    if (!header) return;

    this.header = header;
    this.toggle = header.querySelector('.header__menu-toggle');
    this.nav = header.querySelector('#header-navigation');

    if (!this.toggle || !this.nav) return;

    this.isOpen = false;

    this.toggle.addEventListener('click', () => this.toggleMenu());
    this.nav.addEventListener('click', (e) => {
      if (e.target.closest('a')) this.close();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) this.close();
    });
  }

  open() {
    this.isOpen = true;
    this.header.classList.add('header--menu-open');
    this.toggle.setAttribute('aria-expanded', 'true');
    this.toggle.setAttribute('aria-label', 'Menü schließen');
    document.body.classList.add('header-menu-open');
  }

  close() {
    this.isOpen = false;
    this.header.classList.remove('header--menu-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    this.toggle.setAttribute('aria-label', 'Menü öffnen');
    document.body.classList.remove('header-menu-open');
  }

  toggleMenu() {
    this.isOpen ? this.close() : this.open();
  }
}
